import styled from "@emotion/styled";

export const Header5 = styled.h5(
  {
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "18px",
  },
  ({ theme: { color } }) => ({
    color: color.gray.dark,
  })
);
